export default __webpack_public_path__ + "static/media/Group9256.5e08da8c.svg";